import { PathOptions } from "leaflet";

export const areas_prioritarias_conservacao_caatinga = (
  feature: any
): PathOptions => {
  return {
    fillColor: "#c28616ff",
    color: "#e4ab41ff",
    weight: 0.5,
    fillOpacity: 0.5,
  };
};
